import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';
import authReducer from "features/auth/presentation/store/authSlice";
import headerReducer from "shared/store/headerSlice";
import parkingReducer from "features/parking/presentation/store/parkingSlice";
import { DateTime } from "luxon";



const reducers = combineReducers({
    auth: authReducer,
    header: headerReducer,
    parking: parkingReducer,
});

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ["auth", "parking"], // which reducer want to store
    transforms: [
        {
            in: (state) => {
                if (state.serverTime) {
                    return {
                        ...state,
                        serverTime: new Date(state.serverTime).toISOString() // Ensure serverTime is in ISO format
                    }
                }
                return state;
            },
            out: (state) => {
                if (state.serverTime) {
                    return {
                        ...state,
                        serverTime: DateTime.fromISO(state.serverTime).isValid
                            ? DateTime.fromISO(state.serverTime)
                            : DateTime.now().setZone('Asia/Seoul'),
                    }
                }
                return state;
            },
        },
    ],
};

const persistedReducer = persistReducer(persistConfig, reducers);

export default configureStore({
    reducer: persistedReducer,
    middleware: [thunk]
})

